export enum LoanStatus {
  Cancel,
  Accept,
}
